import { Box, Divider, Link, Stack, styled, useTheme } from '@mui/material';
import mixpanel from 'mixpanel-browser';
import { FC, useContext, useMemo } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import { ELinks, EMixpanelEvent } from '../../util/constants';

const Footer = styled('footer')(({ theme }) => ({
    display: 'flex',
    fontSize: '12px',
    alignItems: 'center',
    flexDirection: 'column',
    color: theme.palette.common.black,
}));

const MBFooterV2: FC = () => {
    const { language } = useContext(GlobalContext);
    const currentYear = useMemo(() => new Date().getFullYear(), []);
    const theme = useTheme();

    return (
        <Footer>
            <Box sx={{ fontSize: '11px' }}>{`\u00A9${currentYear} MINDBODY, Inc.`}</Box>
            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={1}>
                <Link
                    href={ELinks.privacyPolicy}
                    onClick={() => {
                        mixpanel.track(EMixpanelEvent.interacted, { key: 'consumer_privacy' });
                    }}
                    target="_blank"
                    data-testid="legal-privacy"
                    color={theme.palette.text.primary}
                >
                    {`${language.legal.privacyPolicy} ${language.common.and} ${language.legal.privacyRights}`}
                </Link>
                <Link
                    href={ELinks.termsServiceConsumer}
                    onClick={() => {
                        mixpanel.track(EMixpanelEvent.interacted, { key: 'consumer_terms' });
                    }}
                    target="_blank"
                    data-testid="legal-terms"
                    color={theme.palette.text.primary}
                >
                    {language.legal.termsUse}
                </Link>
            </Stack>
        </Footer>
    );
};

export default MBFooterV2;
